import { getReminderDetail } from '@/apis';
import useChatStore from '@/stores/useChatStore';
import useGlobalStore from '@/stores/useGlobalStore';
import { useEffect, useState } from 'react';
import { BREAKPOINTS } from "@/constants/defaultValue";
import useBreakpoint from 'use-breakpoint';
import { MarkdownContent } from './Typewriter';

const ReminderContent = () => {
    const reminderId = useChatStore((state) => state.reminderId);
    const business = useGlobalStore((state) => state.business);
    const [reminder, setReminder] = useState(null);
    const { breakpoint } = useBreakpoint(BREAKPOINTS);
    const isMobile = ["xs", "sm"].includes(breakpoint);

    const fetchReminder = async () => {
        const response = await getReminderDetail({ business, reminderId });
        setReminder(response);
    }

    useEffect(() => {
        if (reminderId) {
            fetchReminder();
        }
    }, [reminderId]);

    if (!reminder) return null;
    return (
        <div>
            <div
                className="p-4 shadow-sm relative bg-[#208DF10D] rounded-lg transition-all duration-200 hover:shadow-md group"
            >
                <div className="absolute top-4 right-4 flex items-center gap-2">
                    <span className={`text-xs text-gray-400`}>{reminder.time}</span>
                </div>

                <div className="flex items-start gap-3">
                    <div className="flex-1 space-y-6 w-full overflow-x-scroll">
                        <h3 className={`font-medium text-gray-900 leading-relaxed pr-12 ${isMobile ? "text-base" : "text-xl"}`}>{reminder.title}</h3>

                        <MarkdownContent content={reminder.content} className="text-gray-700 leading-relaxed text-sm reminder-markdown" />

                        {/* {message?.actions?.length > 0 && (
              <div className="flex items-center gap-2">
                {message.actions.map((action, index) => (
                  <button
                    key={action.id || index}
                    className="flex items-center gap-4 justify-between cursor-pointer px-4 py-2 bg-gradient-to-r bg-white text-sm  hover:bg-slate-50  rounded-lg transition-colors"
                    onClick={() => handleActionClick(action)}
                  >
                    {action.label}

                    <span className="text-xs text-gray-400">
                      <ArrowRight size={20} strokeWidth={1.5} />{" "}
                    </span>
                  </button>
                ))}
              </div>
            )} */}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ReminderContent;